import React from "react";
import * as styles from "./RadioSwitcherList.module.scss";
import classNames from "classnames";
import List from "@app/components/List/List.js";
import ListItem from "@app/components/RadioSwitcherList/ListItem.jsx";
import { Col, Container, Row } from "react-bootstrap";
//import PropTypes from 'prop-types'

const RadioSwitcherList = ({ label, entries, radioOptions, id, headerLabel, className }) => {
	const RadioSwitcherListClassName = classNames({
		[styles["radio-switcher-list"]]: true,
		[className]: true,
	});

	return (
		<div className={RadioSwitcherListClassName}>
			<span className={"fw-bold"}>{label}</span>
			<List
				header={
					<Container key={0} className={"px-0"}>
						<Row>
							<Col className={"d-flex justify-content-end"}>{headerLabel}</Col>
						</Row>
					</Container>
				}
				items={
					entries.length > 0
						? entries.map(({ id: entryId, label, source }) => {
								const name = `${id}['${entryId}']`;
								return (
									<ListItem
										// label={source ? `[${source}] ${label}` : label}
										label={label}
										name={name}
										options={radioOptions.map((radioOption, index) => ({
											id: `${name}-${index}`,
											...radioOption,
										}))}
									/>
								);
							})
						: [<ListItem label={"keine"} options={[]} />]
				}
			/>
		</div>
	);
};

RadioSwitcherList.propTypes = {};

export default RadioSwitcherList;
